import { isPlatformBrowser, ViewportScroller } from "@angular/common";
import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  Inject,
  Input,
  OnInit,
  PLATFORM_ID,
  ViewChild,
  ViewEncapsulation,
} from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup } from "@angular/forms";
import { MatBottomSheet } from "@angular/material/bottom-sheet";
import { MatDialog } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { ActivatedRoute, NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router, RouterEvent } from "@angular/router";
import { Subject } from "rxjs";
import { debounceTime } from "rxjs/operators";


import { Constant } from "src/app/constants/constant";
import { Product } from "src/app/models/app.models";
import { AttributeService } from "src/app/services/attribute.service";
import { CartService } from "src/app/services/cart.service";
import { CommonService } from "src/app/services/common.service";
import { ConfigServiceService } from "src/app/services/config-service.service";
import { ProductService } from "src/app/services/product.service";
import { UserService } from "src/app/services/user.service";
import { environment } from "src/environments/environment";
import { FitersComponent } from "./fiters/fiters.component";
import { SortComponent } from "./sort/sort.component";
import {Location} from '@angular/common';
import { Thumbs } from "swiper";
import { EcryptServiceService } from "src/app/services/ecrypt-service.service";
import { Meta } from "@angular/platform-browser";
@Component({
  selector: "calsoft-products",
  templateUrl: "./products.component.html",
  styleUrls: ["./products.component.scss"],
  encapsulation:ViewEncapsulation.None
})
export class ProductsComponent implements OnInit {
  
  public categories: any;
  public sidenavOpen: boolean = true;
  private sub: any;
  filterRequest: any = [];
  newArr: any = [];
  changesSaved = false;
  searchText: any = {};
  public categoryProducts: any=[];
  public categoryList: any;
  public categoryId: any;
  public priceFrom: any;
  public priceTo: any;
  public products: Array<Product> = [];
  search: any = "";
  manageNameSeperately:any;
  public viewType: string;
  public viewCol: number = 25;
  counts: any = [20];
  public page: number = 0;
  mobileSize: number = 10;
  size: any = this.counts[0];

  @Input() name:any;

  public count: any;
  selection: any = [];
  public brands = [];
  values: any = "*values*";
  public colors = [
    { name: "#5C6BC0", selected: false },
    { name: "#66BB6A", selected: false },
    { name: "#EF5350", selected: false },
    { name: "#BA68C8", selected: false },
    { name: "#FF4081", selected: false },
    { name: "#9575CD", selected: false },
    { name: "#90CAF9", selected: false },
    { name: "#B2DFDB", selected: false },
    { name: "#DCE775", selected: false },
    { name: "#FFD740", selected: false },
    { name: "#00E676", selected: false },
    { name: "#FBC02D", selected: false },
    { name: "#FF7043", selected: false },
    { name: "#F5F5F5", selected: false },
    { name: "#696969", selected: false },
  ];
  public sizes = [
    { name: "S", selected: false },
    { name: "M", selected: false },
    { name: "L", selected: false },
    { name: "XL", selected: false },
    { name: "2XL", selected: false },
    { name: "32", selected: false },
    { name: "36", selected: false },
    { name: "38", selected: false },
    { name: "46", selected: false },
    { name: "52", selected: false },
    { name: '13.3"', selected: false },
    { name: '15.4"', selected: false },
    { name: '17"', selected: false },
    { name: '21"', selected: false },
    { name: '23.4"', selected: false },
  ];

  filterValue: string;
  filterId: any;
  isEmpty: any=false;
  attributeListOptions: any[];
  attributeList: any;
  price: any[];
  priceValue: string;
  b: boolean;
  private serverPath = environment.ImageAPI;
  interests: any;
  s: any;
  attributes: any;
  form: UntypedFormGroup;
  _temp: {};
  pageSize: any;
  spinner: boolean;
  spinnerMain:boolean=false;
  currentWindowWidth: number;
  config: { itemsPerPage: any; currentPage: number; totalItems: any };
  checked: any = [];
  truefalse: any;
  isOverlayVisible: boolean;
  public sortings = [
    { value: "price,DESC", viewValue: "Price - High to Low" },
    { value: "price,ASC", viewValue: "Price - Low to High" },
    { value: "createdDate,DESC", viewValue: "Newest First" },
  ];
    filterMap = new Map<any, any>();
  paths: any = [];
  sortParam: any;
  public sort: string = this.sortings[0].viewValue;
  lastValueChanged: any;
  indexFilter: any;
  condition: string;
  filterPaginate: any = false;
  updatedRange: any;
  filterCategoryId: any;

  @ViewChild("slider") slider;

  @ViewChild("slider", { read: ElementRef }) sliderEl: ElementRef;
  priceFilterApplied: boolean=false;
  noProductValue: boolean=false;
  url: string;
  searchUrl: boolean;
  cartIncremented: any;
  shopingCartVisible: any;
  showCartIcon: any;
  showCartIncremented: any;
  type: string;
  showConfigurableDropdown: any;
  headerName: any;
  otherProductType: boolean=false;
  keyChecked: any=[];
  mobileScreen: boolean=false;
  urlPage: string;
  urlSize: string;
  redirected: boolean=false;
  backButtonClicked: boolean=true;
  productImageWidth: any;
  productImageType: any;
  @Input() data: any;
  productImageWidthMob: any;
  productImageHeightMob: any;
  b2bPricingEnabled: string | number;
  priceEnabled: boolean=true;
  disablePriceFilter: any = 0;
  constructor(
    private activatedRoute: ActivatedRoute,
    //  public categoryListComp: CategoryListComponent,
    public dialog: MatDialog,
    private router: Router,
    private productService: ProductService,
    private commonService: CommonService,
    private route: ActivatedRoute,
    private formBuilder: UntypedFormBuilder,
    private attributeService: AttributeService,
    private snackBar: MatSnackBar,

    private bottomSheet: MatBottomSheet,
    private cdRef: ChangeDetectorRef,
    private userService: UserService,
    private cartServices: CartService,
    private configService :ConfigServiceService,
    private location:Location,
    private ecryptServiceService: EcryptServiceService,
    private viewScroller: ViewportScroller,
    public meta: Meta,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {

    this.config = {
      itemsPerPage: this.size,
      currentPage: this.page,
      totalItems: this.count,
    };
  }



  ngOnInit() {
    this.getConfigData()
 
  }


  getCustomerCount() {

    let authourized = this.userService.getAuthenticatedUser();
  if (authourized) {




    this.cartServices.getCustomerCartProductCount().subscribe(
      (response) => {


        this.values = response;

        let value = localStorage.getItem(Constant.CART_COUNT);
        if (value == null) {
          let encryptedValue = btoa(JSON.stringify(response));

          this.userService.storeProductCartCount(encryptedValue);
        }
      },
      (err) => {}
    );
  }
}

getCourseSubscribed() {

  let authourized = this.userService.getAuthenticatedUser();
if (authourized) {
  this.userService.getCourseSubscribed().subscribe(
    (response) => {


      this.values = response;

      let value = localStorage.getItem(Constant.COURSE_SUBSCRiBED);
      if (value == null) {
        let encryptedValue = btoa(JSON.stringify(response));

        this.userService.storeCourseSubscribed(encryptedValue);
      }
    },
    (err) => {}
  );
}
}





  pricesFilterChange(value) {
    this.modelChanged.next();
    this.updatedRange = value;
  }

  getProductList() {



    if(this.router.url.includes('/products-list/')){
   this.otherProductTypes()
    }
   else if(this.router.url.includes('/custom/')){
      this.customProductSearch()
       }
    else if (this.s != "" && this.s != undefined) {
      this.filterValue = this.route.snapshot.queryParamMap.get("filterValuess");
      this.activatedRoute.queryParams.subscribe((params) => {
        //
        //
        this.spinnerMain=true;
        this.newArr = params["filterValue"];
        this.filterId = params["filterId"];
        this.categoryId = params["filterId"];
        this.checked = params["checked"];
        this.truefalse = params["true"];

        //
        this.filterByAttribute();
        //
      });
    }
  else  if (this.filterMap.size != 0) {
      this.filterByAttribute();
    }

    else if (
      this.activatedRoute.snapshot.params["search"] != "" &&
      this.activatedRoute.snapshot.params["search"] != undefined
    ) {

      this.spinnerMain=true;
      this.search = this.activatedRoute.snapshot.params["search"];

      this.search = this.search.replace(/_/g, " ");
      //this.search = this.search.replace(/"/g, "&");
     // this.search = this.search.replace(/Ro/g, "®");
      this.search = this.search.replace(/BRS/g, "(");
      this.search = this.search.replace(/BREl3jk875/g, ")");



      this.productSearch();
    } else {
      this.spinnerMain=true;
      this.route.params.subscribe((val) => {
        this.categoryId = this.route.snapshot.queryParamMap.get("sid");

        if (this.categoryId) {
          this.newArr = [];
          this.filterRequest = [];
          this.productsByCategory();

          if(this.backButtonClicked){
            this.attribute(decodeURIComponent(this.categoryId));
          }
         
        }
      });
    }
  }
  flag = true;
  clear() {

    this.resetFilter();
this.priceFilterApplied=false;
    if (this.filterMap.size > 0) {
      this.filterByAttribute();
    } else {
      this.getProductList();
    }
  }

  resetFilter(){
    this.filterMap.delete("price");

    if(this.priceEnabled){
      this.slider.slider.destroy();
      this.flag = false;
      this.someRange2[0] = parseInt(this.priceFrom);
      this.someRange2[1] = parseInt(this.priceTo);
  
      this.someRange2 = [];
      this.someRange2.push(parseInt(this.priceFrom));
      this.someRange2.push(parseInt(this.priceTo));
    }
   

    this.cdRef.detectChanges();
    this.flag = true;

    if (this.filterMap.size== 0) {
      this.getProductList();
    }
  }

  onUpdateServer() {
    this.changesSaved = true;
  }

  canDeactivate() {
    if (this.changesSaved) {
      return true;
    } else {
      return confirm("Do you want to discard changes");
    }
  }



  public changeCount(count) {
    this.size = count;
    this.page = 0;
    this.getProductList();
  }

  public changeSorting(sort) {
    this.sort = sort.viewValue;
    this.sortParam = sort.value;
    this.page = 0;

    this.getProductList();
  }

  public changeViewType(viewType, viewCol) {
    this.viewType = viewType;
    this.viewCol = viewCol;
  }

  public onPageChanged(event) {
    this.config.currentPage = event;
    if (window.innerWidth > 768) {
      this.redirected=false;
      let localtion=this.router.url;
      localtion=localtion.split('&page')[0]
      this.page = event
      this.location.go(`${localtion}&page=${event}&size=${this.size}`)
      this.page = event-1;
      if (
        this.activatedRoute.snapshot.params["search"] != "" &&
        this.activatedRoute.snapshot.params["search"] != undefined
      ) {
        this.search = this.activatedRoute.snapshot.params["search"];
        this.productSearch();
      } 
      else if (this.newArr.length>0) {
        this.filterPaginate = true;
        this.filterByAttribute();
      } else if(this.router.url.includes('/custom/')){

        this.customProductSearch();
      }
      
      else {
        this.productsByCategory();
      }
      if (isPlatformBrowser(this.platformId)) {
        window.scrollTo(0,0);
      }
      

     this.page=event
      this.config = {
        itemsPerPage: this.size,
        currentPage: this.page,
        totalItems: this.count,
      };

     
     
    

    }

  }

  public onScroll() {
    if (window.innerWidth<850 && this.page<this.pageSize) {
      this.page++;

      this.spinner = true;
      if (this.categoryProducts.length <this.count ) {
        if (
          this.activatedRoute.snapshot.params["search"] != "" &&
          this.activatedRoute.snapshot.params["search"] != undefined
        ) {
          this.search = this.activatedRoute.snapshot.params["search"];
          let value = 1;
          let search =
          "isInStock:" +
          "*" +
          value +
          "*" +
          "' AND name:" +
          "*" +
          this.search.trim() +
          "*" +
          "' " +
          "' OR sku:" +
          "*" +
          this.search.trim() +
          "*" +
          "' ";
          this.productService
            .getProductBySearch(
              search,
              this.page,
              this.mobileSize,
              this.sortParam
            )
            .subscribe((res) => {
              this.spinner = false;
              this.categoryProducts = [ ...this.categoryProducts, ...res['content']];

            });
        }
       else if (this.newArr.length>0) {

          let values = this.route.snapshot.queryParamMap.get("sid");
          this.productService
            .filterByCategoryId(
              values,
              this.newArr,
              this.page,
              this.mobileSize,
              this.sortParam
            )
            .subscribe((res) => {
              this.spinner = false;
              this.categoryProducts = [ ...this.categoryProducts, ...res['content']];
            });
              (error) => {
                this.spinner = false;
              };

        } 
        else if (this.router.url.includes('/custom/')) {

          let decryptedData = this.route.snapshot.queryParamMap.get("sid");
    
       decryptedData=this.ecryptServiceService.decryptionAES(decryptedData);
    
       this.search=decryptedData;
             
        this.productService
          .getProductByCustomProductId(this.search, this.page, this.size, this.sortParam)
          .subscribe((res) => {
              this.spinner = false;
              this.categoryProducts = [ ...this.categoryProducts, ...res['content']];
            });
              (error) => {
                this.spinner = false;
              };

        } 
        
        
        
        
        else {
          this.productService
            .productsByCategoryIdx(
              decodeURIComponent(this.categoryId),
              this.page,
              this.mobileSize,
              this.sortParam
            )
            .subscribe((res) => {
              this.spinner = false;
              this.categoryProducts = [ ...this.categoryProducts, ...res['content']];


            });
        }
      } else {
        this.spinner = false;
        //this.noProduct();
        this.noProductValue=true;
      }
    }
  }
  noProduct() {
    this.snackBar.open("No product found", "×", {
      panelClass: "success",
      verticalPosition: "bottom",
      duration: 3000,
    });
  }

  public onChangeCategory(event) {
    if (event.target) {
      this.router.navigate(["/products", event.target.innerText.toLowerCase()]);
    }
  }
  public productsByCategory() {


if(window.innerWidth<850){
  this.size=this.mobileSize

}else{
  this.size=this.size;

  this.checkIfContains()


}
    this.productService
      .productsByCategoryIdx(
        decodeURIComponent(this.categoryId),
        this.page,
        this.size,
        this.sortParam
      )
      .subscribe((res) => {

         if(res!=undefined){

          this.categoryProducts = res["content"];

          this.count = res["totalElements"];
          this.isEmpty = res["empty"];
          this.pageSize = res["totalPages"];

          if(this.redirected){
          if(this.urlPage!=null){
          
            this.page= parseInt(this.urlPage)
          
         
          }
          if(this.urlSize!=null){
            this.size=parseInt(this.urlSize)
          }
        }
          (this.config.currentPage = this.page),
            (this.config.totalItems = this.count),
            (this.config.itemsPerPage = this.size);
            this.getcount();
      
        }else{
          this.isEmpty = true;

        }
        this.spinnerMain=false;

      },
      (err) => {
        this.isEmpty = true;
        this.spinnerMain=false;});
  }
  checkIfContains() {
    if(this.redirected){

  
      if(this.urlPage!=null){
        this.urlPage=  this.route.snapshot.queryParamMap.get("page");
        this.page=  parseInt(this.urlPage)-1
      
     
      }else{
        this.page=0;
      }
      if(this.urlSize!=null){
        this.size=parseInt(this.urlSize)
      } else{
     this.size= this.counts[0];
      }
    }
    
  }

  getcount() {

    let value1=  localStorage.getItem('pgs');

    if(value1==="3"&&this.viewType=='grid'){

      if(this.count <= 21){
        this.counts = [21];
      }
      else if (this.count <= 42) {
        this.counts = [21, 42];
      } else if (this.count <= 63) {
        this.counts = [21, 42,63];
      } else if (this.count > 63) {
        this.counts = [21, 42,63];
      } else {
        this.counts = [21];
      }

    }else{
      if(this.count <= 20){
        this.counts = [20];
      }
      else if (this.count <= 40) {
        this.counts = [20, 40];
      } else if (this.count <= 60) {
        this.counts = [20, 40,60];
      } else if (this.count > 60) {
        this.counts = [20, 40,60];
      } else {
        this.counts = [20];
      }
    }

   

  }

  productSearch() {
this.viewType = 'grid'
let value1=  localStorage.getItem('pgs')
this.setViewCol(value1,'search');
if(window.innerWidth<850){
  this.size=this.mobileSize
}else{
  this.size=this.size;
  this.checkIfContains()
}




  }

  productSearchFinal(){

    this.search = this.search.replace(/_/g, " ");
    this.search = this.search.replace("FWDSLS", "/");


   let decryptedData = this.route.snapshot.queryParamMap.get("sid");

   decryptedData=this.ecryptServiceService.decryptionAES(decryptedData);

   this.search=decryptedData;
   
    this.categoryProducts = [];

    let search=null;
    let value = 1;
    if(this.search=="isInStock:*1*' AND featured:*1*' "){
   search = "isInStock:" + '*' + value + '*'
      + "' AND featured:" + '*' + value + '*' + "' "
    }else{
    search = "name:" + '*' + this.search.trim() + '*'
      + "' OR sku:" + '*' + this.search.trim() + '*' + "' "
      + "' OR keyword:" + '*' + this.search.trim() + '*' + "' "

    
    }

    

    this.productService
    .getProductBySearch(search, this.page, this.size, this.sortParam)
    .subscribe((res) => {

      if(res!=null){
        this.categoryProducts = res["content"];
        this.count = res["totalElements"];
        this.isEmpty = res["empty"];
        this.pageSize = res["totalPages"];
      }else{
        this.categoryProducts = [];
        this.count = 0;
        this.isEmpty = true;
        this.pageSize = 0;
      }
    
      if(this.redirected){
        if(this.urlPage!=null){
        
          this.page= parseInt(this.urlPage)
        
       
        }
        if(this.urlSize!=null){
          this.size=parseInt(this.urlSize)
        }
      }
      (this.config.currentPage = this.page),
        (this.config.totalItems = this.count),
        (this.config.itemsPerPage = this.size);
      this.getcount();

         this.spinnerMain=false;
    },   (err) => { this.spinnerMain=false;});
  }


  customProductSearch() {
    this.otherProductType=true;
    this.viewType = 'grid'
    let value1=  localStorage.getItem('pgs')
    this.setViewCol(value1,'customProductSearch')
    if(window.innerWidth<850){
      this.size=this.mobileSize
    }else{
      this.size=this.size;
      this.checkIfContains()
    }
      

      }


      customProductSearchFinal(){
        let decryptedData = this.route.snapshot.queryParamMap.get("sid");
    
        decryptedData=this.ecryptServiceService.decryptionAES(decryptedData);
     
        this.search=decryptedData;
        
         this.categoryProducts = [];
     
         
         this.productService
           .getProductByCustomProductId(this.search, this.page, this.size, this.sortParam)
           .subscribe((res) => {
     
             if(res!=null){
               this.categoryProducts = res["content"];
               this.count = res["totalElements"];
               this.isEmpty = res["empty"];
               this.pageSize = res["totalPages"];
             }else{
               this.categoryProducts = [];
               this.count = 0;
               this.isEmpty = true;
               this.pageSize = 0;
             }
           
             if(this.redirected){
               if(this.urlPage!=null){
               
                 this.page= parseInt(this.urlPage)
               
              
               }
               if(this.urlSize!=null){
                 this.size=parseInt(this.urlSize)
               }
             }
             (this.config.currentPage = this.page),
               (this.config.totalItems = this.count),
               (this.config.itemsPerPage = this.size);
             this.getcount();
     
                this.spinnerMain=false;
           },   (err) => { this.spinnerMain=false;});
      }

  productShow(product) {

      this.commonService.productNavigation(product);

  }

  filterByAttribute() {
    if(!this.priceFilterApplied){

      this.resetFilter();

    }
    const convMap = {};
    this.newArr = [];
    this.filterRequest = [];
    this.filterMap.forEach((val: string, key: string) => {
      convMap[key] = val;
      this.filterRequest.push({ [key]: val });

      this.newArr = this.filterRequest;
    });

    if (!this.filterPaginate) {
      this.page = 0;
    }
    this.filterPaginate = false;
    let values = this.route.snapshot.queryParamMap.get("sid");
    this.productService
      .filterByCategoryId(
        values,
        this.newArr,
        this.page,
        this.size,
        this.sortParam
      )
      .subscribe((res) => {
        this.categoryProducts = res["content"];
        this.count = res["totalElements"];
        this.isEmpty = res["empty"];
        this.pageSize = res["totalPages"];
        (this.config.currentPage = this.page),
          (this.config.totalItems = this.count),
          (this.config.itemsPerPage = this.size);
        this.getcount();
        //
        this.pageSize = res["totalPages"];
        this.spinnerMain=false;

      },    (err) => {

        this.spinnerMain=false;
      });
    }


  attribute(categoryId) {

 
    this.attributeListOptions = [];
    this.attributeList = [];
    this.price = [];
    this.priceFrom = "";
    this.priceTo = "";
    let values = this.route.snapshot.queryParamMap.get("sid");

    this.attributeService.attribute(values).subscribe((res) => {
      this.attributeList = res;

      this.priceValue = "Price";
      this.price = res[this.priceValue];
      //
      if ( this.price != undefined) {
        this.b = delete res[this.priceValue];
        //
        this.priceFrom = parseFloat(this.price[0]).toFixed() ;
        this.priceTo = parseFloat(this.price[1]).toFixed() ;
        if (isNaN(this.priceFrom )) {
          let value:any=0.0;
          this.priceFrom =parseFloat(value);
        } 
        this.someRange2[0] = parseInt(this.priceFrom);
        this.someRange2[1] = parseInt(this.priceTo);
        this.sliderConfig.range.min = parseInt(this.priceFrom);
        this.sliderConfig.range.max = parseInt(this.priceTo);
      }
      (error) => {};
    });
  

  }

  filter = new Map<any, any>();
  filterCheckBox: any = [];
  filterColumn(event, id, i) {
    this.condition = null;

    this.s = id + "_s";
    if (event.checked) {
      if (this.filterMap.get(this.s) == undefined) {
        this.filterMap.set(this.s, event.source.value);
      } else {
        this[this.s] = this.filterMap.get(this.s) + "#" + event.source.value;

        this.filterMap.set(this.s, this[this.s]);
      }
this.filterCheckBox.push(id+event.source.value);
this.keyChecked.push(id);
      this.filterByAttribute();
    } else {

      var indexCheckKey = this.keyChecked.indexOf(id);

      this.keyChecked.splice(indexCheckKey, 1);
      this.condition = this.filterMap
        .get(this.s)
        .replace(event.source.value, "");

      let index = this.condition.length - 1;

      if (this.condition[index] == "#") {
        this.condition = this.condition.substring(0, index);

        this.filterMap.set(this.s, this.condition);
      } else if (this.condition.length == 0) {
        this.filterMap.delete(this.s);
      } else {
        this.filterMap.set(this.s, this.condition);
      }

      if (
        this.filterMap.get(this.s) != undefined &&
        this.filterMap.get(this.s).charAt(0) == "#"
      ) {
        this.condition = this.filterMap.get(this.s).slice(1);
        this.filterMap.set(this.s, this.condition);
      }
      if (this.filterMap.size != 0) {
        this.filterByAttribute();
      } else {
        this.page = 0;
        this.productsByCategory();
      }

      var indexCheckValue = this.filterCheckBox.indexOf(id+event.source.value);

      if (indexCheckValue > -1) {
        this.filterCheckBox.splice(indexCheckValue, 1);
      }
    }
  }

  public onUp(event) {
    if (window.innerWidth <= 768) {
      this.page--;

      this.spinner = true;
      if (this.page < this.pageSize) {
        if (
          this.activatedRoute.snapshot.params["search"] != "" &&
          this.activatedRoute.snapshot.params["search"] != undefined
        ) {
          let search=null;
          let value = 1;
          if(this.search=="isInStock:*1*' AND featured:*1*' "){
            search = "isInStock:" + '*' + value + '*'
               + "' AND featured:" + '*' + value + '*' + "' "
             }else{

               search =
                "isInStock:" +
                "*" +
                value +
                "*" +
                "' AND name:" +
                "*" +
                this.search.trim() +
                "*" +
                "' " +
                "' OR sku:" +
                "*" +
                this.search.trim() +
                "*" +
                "' ";
             }

          this.sortParam = "price,DESC";
          this.productService
            .getProductBySearch(
              this.search,
              this.page,
              this.size,
              this.sortParam
            )
            .subscribe((res) => {
              for (const productsss of res["content"]) {
                this.categoryProducts.push(productsss);
                this.spinner = false;
              }
            });
        }
        if (this.s != "" && this.s != undefined) {
          let values = this.route.snapshot.queryParamMap.get("sid");
          this.productService
            .filterByCategoryId(
              values,
              this.newArr,
              this.page,
              this.size,
              this.sortParam
            )
            .subscribe((res) => {
              for (const productsss of res["content"]) {
                this.categoryProducts.push(productsss);
                this.spinner = false;
              }

              (error) => {
                this.spinner = false;
              };
            });
        }  else if (this.router.url.includes('/custom/')) {

          let decryptedData = this.route.snapshot.queryParamMap.get("sid");
    
       decryptedData=this.ecryptServiceService.decryptionAES(decryptedData);
    
       this.search=decryptedData;
             
        this.productService
          .getProductByCustomProductId(this.search, this.page, this.size, this.sortParam)
          .subscribe((res) => {
              this.spinner = false;
              this.categoryProducts = [ ...this.categoryProducts, ...res['content']];
            });
              (error) => {
                this.spinner = false;
              };

        } 
        
        else {
          this.productService
            .productsByCategoryIdx(
              this.categoryId,
              this.page,
              this.size,
              this.sortParam
            )
            .subscribe((res) => {
              for (const productsss of res["content"]) {
                this.categoryProducts.push(productsss);

                this.spinner = false;
              }
            });
        }
      } else {
        this.spinner = false;
        this.noProduct();
      }
    }
  }

  filters() {
    if (window.innerWidth < 1024) {
      let dialogRef = this.dialog.open(FitersComponent, {
        minWidth: "100vw",
        height: "100vh",
        data: {
          page: this.attributeList,
          checked: this.checked,
          map: this.filterMap,
          total: this.count,
          min:  this.priceFrom,
          max:this.priceTo,
          keyChecked:this.keyChecked

        },
      });
      dialogRef.disableClose = true;
      dialogRef.afterClosed().subscribe((result) => {
        if (result["event"] == "update") {
          this.selection = result["result"];
          this.checked = result["checked"];
          this.filterMap = result["data"];
        this.keyChecked=result["keyChecked"];
          if (this.filterMap.size != 0) {
            if(this.filterMap.get("price")!== undefined){
              this.priceFilterApplied=true;
            }else{
              this.priceFilterApplied=false;
            }
            this.filterByAttribute();

          } else {
            this.productsByCategory();
          }
        }
      });
    } else {
    }
  }

  public someRange2: number[] = [0, 10];

  rangeChanged(updatedRange): void {
    this.filterMap.set(
      "price",
      updatedRange[0].toFixed() + "#" + updatedRange[1].toFixed()
    );
  }

  applyPriceFilter() {
    this.priceFilterApplied=true;
    this.filterByAttribute();
  }
  modelChanged = new Subject<string>();

  public sliderConfig: any = {
    step: 1,
    range: {
      min: 0,
      max: 10,
    },
    tooltips: [true, true],
  };

  sortMobile(): void {
    const bottomSheetRef = this.bottomSheet.open(SortComponent, {
      data: {
        sort: this.sort,
        sortData: this.sortings,
      },
    });
    bottomSheetRef.afterDismissed().subscribe((data) => {
      if (data.event == "update") {
        if (data.sort.viewValue != this.sort) {
          this.changeSorting(data.sort);
        }
      }
    });
  }

  productImageHeight:any;

  getConfigData() {
    this.configService.getConfigData()
      .subscribe(
        data => {
          
          this.data=data;
          if(this.data['b2bPricingEnabled']==1){
            this.b2bPricingEnabled=localStorage.getItem
            (Constant.B2B_USER)==null?0:
            localStorage.getItem(Constant.B2B_USER);
    
            if(this.b2bPricingEnabled==1){
              this.priceEnabled=false;
            }
           }
          this.showCartIcon= data['showCartProductPage'];
          let url= data['baseUrl']+this.router.url;
          this.meta.updateTag({ rel: 'canonical', href: url });
          this.showCartIncremented=data['showCartIncremented']

          this.showConfigurableDropdown=data['showConfigurableDropdownProductPage']

          this.productImageHeight=data['productsImageHeight'];

          this.productImageWidth=data['productsImageWidth']

          this.productImageType=data['productsImageType']

          this.productImageWidthMob=data['productsImageWidthMob']

          this.disablePriceFilter=data['disablePriceFilter']

          this.productImageHeightMob=data['productsImageHeightMob'];

          this.sort=data['priceSortings']==undefined?this.sortings[0].viewValue:data['priceSortings']=='price,DESC'?'Price - High to Low':data['priceSortings']=='price,ASC'?'Price - Low to High':'Newest First'
          this.sortParam=data['priceSortings']==undefined?this.sortings[0].value:data['priceSortings']
          this.redirected=false;
          let value1=  localStorage.getItem('pgs')
          this.counts=value1=="3"?[21]:[20];
          this.size=this.counts[0]
       this.urlPage=  this.route.snapshot.queryParamMap.get("page")
       this.urlSize=  this.route.snapshot.queryParamMap.get("size")
      
      if(this.urlPage!=null){
        this.redirected=true;
      }
         
          if (window.innerWidth < 1000) {
      
            this.mobileScreen=true;
      
          }else{
            this.mobileScreen=false;
          }
            
      this.type=='product';
      let authourized = this.userService.getAuthenticatedUser();
      let guestLoginEnabled=localStorage.getItem(Constant['GUEST_LOGIN'])
     
      


   

          if (authourized||guestLoginEnabled=="1") {
          this.cartServices.getCustomerCartProductCount()
          this.cartServices.geWishListProduct();
          }
         
      
          this.url=this.router.url;
      
          if(this.router.url.includes("search/")){
            this.searchUrl=true;
          
          }else{
            this.searchUrl=false;
          }
          this.getProductList();
          this.categoryId = this.route.snapshot.queryParamMap.get("sid");
      
      
          this.spinner = false;
         
          this.currentWindowWidth = window.innerWidth;
          this.count = this.counts[0];
         
        
          if (window.innerWidth < 960) {
            this.sidenavOpen = false;
          }
          if (window.innerWidth < 1280) {
            this.viewCol = 33.3;
          }
          
          this.form = this.formBuilder.group({
            interests: this.formBuilder.array([]),
          });
      
          this.isOverlayVisible = false;
      
          this.modelChanged.pipe(debounceTime(150)).subscribe((event) => {
            //
            this.rangeChanged(this.updatedRange);
          });
          this.getCustomerCount();
      
          this.getCourseSubscribed();
          

          }, error => {

          }
          );
}




public otherProductTypes() {

  this.otherProductType=true;
let products=[]

let encryptedData= this.route.snapshot.queryParamMap.get("pid");

  let decryptedData=this.commonService.getValueForDecryptedData(encryptedData)


  this.headerName = this.activatedRoute.snapshot.params["header"];

  products=JSON.parse(decryptedData)

  this.count = products.length;
            this.isEmpty = products.length>0?false:true;
            this.pageSize =1;
            (this.config.currentPage = this.page),
              (this.config.totalItems = this.count),
              (this.config.itemsPerPage = this.size);

              this.categoryProducts = products;

    }

    @HostListener('window:popstate', ['$event'])
    onPopState(event) {
    
      this.backButtonClicked=false;
      this.redirected=true;
      this.getProductList();
    }

    getProductTypeProduct(event){
      this.viewType = event;
      let value=  localStorage.getItem('pgs')
     this.setViewCol(value,'product');
        
      if(this.viewType!='grid'){
        this.counts=[20];
        this.size=this.counts[0]
        this.getcount()
      }
      
    }
    
    setViewCol(value,type){

      if(this.viewType=='grid'){

        if(value==3){

          this.viewCol =33.33
          this.counts=[21];

        }else if(value==2){
          this.viewCol =50
          this.counts=[20];
        }else if(value==5){
          this.viewCol =20
          this.counts=[20];
        }else{
          this.viewCol =25
          this.counts=[20];
        }
      }

      if(type=='product'){
        this.getProductList();
      }else if(type=='customProductSearch'){

        this.customProductSearchFinal();
      }
      else{
        this.productSearchFinal();

      }
      

    
    }

}
